import {Component, OnInit} from '@angular/core';
import {CommonServices} from './services/common.services';
import {MessageService} from './services/message.service';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import { IAppState } from 'app/IAppState';

const envSelector = (state: IAppState) => state.environmentState;
@Component({
  selector: 'biz-global-proxy',
  templateUrl: './global-proxy.component.html',
  styleUrls: ['./global-proxy.component.scss']
})
export class GlobalProxyComponent implements OnInit {

  globalProxy: IEnvironmentProxy;
  environment: IProxyObject;
  bizagiEnv;

  constructor(private commonService: CommonServices, private messageService: MessageService,  private store: Store<IAppState>) {
  }

  async ngOnInit() {
    const response = await this.commonService.getObject();

    if (response) {
      this.globalProxy = response;
    }
    this.store.pipe(select(envSelector)).pipe(take(1)).subscribe(env => {
      this.bizagiEnv = env;
      this.environment = this.globalProxy.environments[this.bizagiEnv.environment];
    })
  }



  async save() {
    try {
      const response = await this.commonService.updateObject(this.globalProxy);
      if (response) {
        this.messageService.showMessage('The configuration proxy was updates successfully', {
          type: 'success',
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 2000
        });
      } else {
        this.messageService.showError("Ups! an error has ocurred");
      }
    } catch (e) {
      this.messageService.showError(e.message);
    }
  }


}
